import { baseApiClient as api } from "../baseService";

export const addTagTypes = ["agentflow"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      agentflowGetEvalForm: build.query<
        AgentflowGetEvalFormApiResponse,
        AgentflowGetEvalFormApiArg
      >({
        query: (queryArg) => ({
          url: `/api/agentflow/eval/${queryArg.matterId}/${queryArg.approvalId}/`,
        }),
        providesTags: ["agentflow"],
      }),
      agentflowSubmitEvalForm: build.mutation<
        AgentflowSubmitEvalFormApiResponse,
        AgentflowSubmitEvalFormApiArg
      >({
        query: (queryArg) => ({
          url: `/api/agentflow/eval/${queryArg.matterId}/${queryArg.approvalId}/submit/`,
          method: "POST",
          body: queryArg.submitEvalFormRequest,
        }),
        invalidatesTags: ["agentflow"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type AgentflowGetEvalFormApiResponse =
  /** status 200  */ EvalFormConfigResponse;
export type AgentflowGetEvalFormApiArg = {
  approvalId: string;
  matterId: string;
};
export type AgentflowSubmitEvalFormApiResponse =
  /** status 200  */ SubmitEvalFormResponse;
export type AgentflowSubmitEvalFormApiArg = {
  approvalId: string;
  matterId: string;
  submitEvalFormRequest: SubmitEvalFormRequest;
};
export type EvalFormConfigResponse = {
  /** JSON Schema for form generation */
  response_schema: {
    [key: string]: any;
  };
  /** Form title */
  form_title?: string | null;
  /** Form description */
  form_description?: string | null;
  /** Optional task context for display (not rendered as a form field) */
  task_id?: (string | string) | null;
  /** Optional policy key used to generate this eval form */
  policy_key?: string | null;
  /** Optional call-launch context metadata (recommended action, provider directory details) */
  launch_context?: {
    [key: string]: any;
  } | null;
  /** Optional frontend renderer key; if omitted, clients should use schema-based default rendering */
  ui_renderer?: string | null;
};
export type SubmitEvalFormResponse = {
  ok: boolean;
  message?: string | null;
};
export type SubmitEvalFormRequest = {
  /** Form data matching the response_schema (legacy field) */
  form_data?: {
    [key: string]: any;
  } | null;
  /** Form data matching the response_schema (preferred field) */
  modified_data?: {
    [key: string]: any;
  } | null;
  /** Action type (optional, defaults to 'submit') */
  action?: string | null;
};
export const {
  useAgentflowGetEvalFormQuery,
  useAgentflowSubmitEvalFormMutation,
} = injectedRtkApi;
